import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import ReceiveSetsHeader from './components/ReceiveSetsHeader/ReceiveSetsHeader';
import ReceiveSetsFooter from './components/ReceiveSetsFooter';
// import Category from './components/category/Category';
import ReceiveSetsLoc from './components/ReceiveSetsLoc';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { ordersWCMSLinks } from 'src/constants/wcmsRedirectionLinks';

import {
    getOrderListData,
    setOrderSummaryModalState,
    closeOrderSummaryModalState,
    getDistrict,
    getRefinedOrderListData,
    setOrderStatus,
    getOrderSummaryData,
    setQuickFilter,
    // setCategoryFilter,
    actionApplyFilterType,
    setSearchParams,
    //resetAppliedFilter,
    refineFilterAndOrderList, //Two Calls Actions
    setOrderDateAction,
    setDynamicZIndex,
    showHideSearchModalAction,
    toggleSearchResult,
} from 'src/pages/orders/redux/actions';
import { setActiveNavLink } from 'src/pages/home/redux/actions/index';
import { useParams, useHistory } from 'react-router-dom';
import {
    isMobileView,
    setDynatracePageName,
    preventBouncingEffect,
    isMobileDevice,
    checkImpersonationActive,
    checkProxyActive,
    logErrorToConsole,
} from 'src/utils/util';
import { RESET_CANCEL_USAGE_STATES } from 'src/pages/reportUsage/redux/action/types';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import {
    bulkBarcodeDetailsData,
    createReceiveSets,
    deleteAllSets,
    resetBulkBarcodeDetailsData,
    resetCreateReceiveSets,
    resetDetailsDropdownsReducer,
    resetReceiveSetsListDataReducer,
    resetSurgeryDetails,
    resetTerritoryReceiveSets,
    saveSetsOutsideTerritoryList,
    setBarcodeDetails,
    setCategoryFilter,
    setProductDetails,
    setReceiveSetUnsavedChangesPopup,
    storeIsSubmitValue,
} from 'src/pages/receiveSets/redux/actions';
import SetsManualEntry from './components/ReceiveSetsLoc/SetsManualEntry';
import { getUser } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import {
    CC_USER_ROLE,
    ITA_USER_ROLE,
    CSR_USER_ROLE,
    pageNames,
    INVENTORY,
    MENU,
} from 'src/constants/appConstants';
import UnsavedChanges from './components/notifications/UnsavedChanges';
import InventoryTabListContainer from './components/tabList/InventoryTabListContainer';
import { getProxyList } from '../more/pages/proxies/redux/action';
import { useTranslation } from 'react-i18next';
import { getConfigurations } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';


const ReceiveSets = () => {
    const { t } = useTranslation();
    const [counterMessage, setCounterMessage] = useState(0);
    const dispatch = useDispatch();
    const employeeRole = getUser();
    const [isSubmitClicked, setIsSubmitClicked] = useState(false);
    const [territoryValue, setTerritoryValue] = useState('');
    const [accountValue, setAccountValue] = useState('');
    const [outsideTerritoryPopup, setOutsideTerritoryPopup] = useState(false);
    const [setFieldFocus, setSetFieldFocus] = useState(false);
    const [popupDetails, setPopupDetails] = useState({
        showDiscardPopup: false,
        id: null,
    });
    const { linkMyCaseRef } = useParams();
    const { filter } = useSelector((state) => state.appliedOrdersFilterReducer);
    const history = useHistory();
    const appliedUserFilters = useSelector(
        (state) => state.appliedOrdersFilterReducer
    );
    const setsOutsideTerritoryList = useSelector(
        (state) => state.receiveSetsListDataReducer.setsOutsideTerritoryList
    );
    const userDetailsLoading = useSelector(
        (state) => state.loginReducer.userDetailsLoading
    );

    const isSubmittedPage = useSelector(
        (state) => state.createReceiveSetsReducer.isSubmittedPage
    );
    const { orderSummaryModal } = useSelector(
        (state) => state.orderSummaryReducer
    );

    const { searchParams, showSearchModal } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );
    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    const { configRule } = useSelector((state) => state.loginReducer);
    const { receiveSets, items, returnSets, sets, consigned } = useSelector(
        (state) => state.loginReducer.inventoryVisibility
    );

    const surgeryContainerRef = useRef();
    const subContainerRef = useRef();

    const checkNotAllowedUser = () => {
        return (
            (employeeRole &&
                (employeeRole === CC_USER_ROLE ||
                    employeeRole === ITA_USER_ROLE ||
                    employeeRole === CSR_USER_ROLE) &&
                !checkImpersonationActive() &&
                !checkProxyActive()) ||
            ((checkImpersonationActive() || checkProxyActive()) &&
                (employeeRole === CC_USER_ROLE ||
                    employeeRole === ITA_USER_ROLE ||
                    employeeRole === CSR_USER_ROLE))
        );
    };

    useEffectWithErrorLogging(() => {
        surgeryContainerRef.current?.scrollTo(0, 0);
        subContainerRef.current?.scrollTo(0, 0);
    }, [isSubmitClicked]);

    const { orderListStartDate, orderListEndDate } = useSelector(
        (state) => state.ordersListReducer.ordersFilterDates
    );

    // const [categoryAnchorEl, setCategoryAnchorEl] = useState(null);
    const DummyCategoryLists = [];
    const DummyTabLists = [];
    if (receiveSets && !checkNotAllowedUser()) {
        DummyCategoryLists.push({
            id: 1,
            categoryName: 'Receive Sets',
            orderType: 'receive_sets',
        });

        DummyTabLists.push({
            id: 1,
            categoryName: 'Receive Sets',
            orderType: 'receive_sets',
            label: t('receiveSets.tablist.receiveSets'),
        });
    }
    if (sets) {
        DummyCategoryLists.push({
            id: 2,
            categoryName: 'Sets',
            orderType: 'sets',
        });
        DummyTabLists.push({
            id: 2,
            categoryName: 'Sets',
            orderType: 'sets',
            label: t('receiveSets.tablist.sets'),
        });
    }
    if (items) {
        DummyCategoryLists.push({
            id: 3,
            categoryName: 'Items',
            orderType: 'items',
        });
        DummyTabLists.push({
            id: 3,
            categoryName: 'Items',
            orderType: 'items',
            label: t('receiveSets.tablist.items'),
        });
    }
    if (returnSets && !checkNotAllowedUser()) {
        DummyCategoryLists.push({
            id: 4,
            categoryName: 'Returned Sets',
            orderType: 'returned_sets',
        });
        DummyTabLists.push({
            id: 4,
            categoryName: 'Returned Sets',
            orderType: 'returned_sets',
            label: t('receiveSets.tablist.returnedSets'),
        });
    }
    if (consigned) {
        DummyCategoryLists.push({
            id: 5,
            categoryName: 'Consigned',
            orderType: 'consigned',
        });
        DummyTabLists.push({
            id: 5,
            categoryName: 'Consigned',
            orderType: 'consigned',
            label: t('receiveSets.tablist.consigned'),
        });
    }

    const [categoryList, setCategoryList] = useState([]);
    const [categoryName, setCategoryName] = useState(
        DummyTabLists?.length > 0 && DummyTabLists[0].categoryName
    );

    const [tabList, setTabList] = useState([]);
    const [selectedTabId, setSelectedTabId] = useState(DummyTabLists?.length > 0 && DummyTabLists[0].id);

    useEffectWithErrorLogging(()=>{
        dispatch(getConfigurations({resourceType: 'PROCESS', module:'INVENTORY'}, INVENTORY));
    },[]);
    
    useEffectWithErrorLogging(() => {
        if (configRule?.optionChosen===INVENTORY) {
            //dispatch(getProxyList());
            let CategoryLists = [];
            let TabLists = [];
            if (!receiveSets || checkNotAllowedUser()) {
                window.location.href = ordersWCMSLinks('sets');
                if (sets) {
                    CategoryLists.push({
                        id: 2,
                        categoryName: 'Sets',
                        orderType: 'sets',
                    });
                    TabLists.push({
                        id: 2,
                        categoryName: 'Sets',
                        orderType: 'sets',
                        label: t('receiveSets.tablist.sets'),
                    });
                }
                if (items) {
                    CategoryLists.push({
                        id: 3,
                        categoryName: 'Items',
                        orderType: 'items',
                    });
                    TabLists.push({
                        id: 3,
                        categoryName: 'Items',
                        orderType: 'items',
                        label: t('receiveSets.tablist.items'),
                    });
                }
                if (consigned) {
                    CategoryLists.push({
                        id: 5,
                        categoryName: 'Consigned',
                        orderType: 'consigned',
                    });
                    TabLists.push({
                        id: 5,
                        categoryName: 'Consigned',
                        orderType: 'consigned',
                        label: t('receiveSets.tablist.consigned'),
                    });
                }
            } else {
                if (receiveSets) {
                    CategoryLists.push({
                        id: 1,
                        categoryName: 'Receive Sets',
                        orderType: 'receive_sets',
                    });
                    TabLists.push({
                        id: 1,
                        categoryName: 'Receive Sets',
                        orderType: 'receive_sets',
                        label: t('receiveSets.tablist.receiveSets'),
                    });
                    setSelectedTabId(TabLists[0].id);
                    setCategoryName(TabLists[0].categoryName);
                }
                if (sets) {
                    CategoryLists.push({
                        id: 2,
                        categoryName: 'Sets',
                        orderType: 'sets',
                    });
                    TabLists.push({
                        id: 2,
                        categoryName: 'Sets',
                        orderType: 'sets',
                        label: t('receiveSets.tablist.sets'),
                    });
                }
                if (items) {
                    CategoryLists.push({
                        id: 3,
                        categoryName: 'Items',
                        orderType: 'items',
                    });
                    TabLists.push({
                        id: 3,
                        categoryName: 'Items',
                        orderType: 'items',
                        label: t('receiveSets.tablist.items'),
                    });
                }
                if (returnSets) {
                    CategoryLists.push({
                        id: 4,
                        categoryName: 'Returned Sets',
                        orderType: 'returned_sets',
                    });
                    TabLists.push({
                        id: 4,
                        categoryName: 'Returned Sets',
                        orderType: 'returned_sets',
                        label: t('receiveSets.tablist.returnedSets'),
                    });
                }
                if (consigned) {
                    CategoryLists.push({
                        id: 5,
                        categoryName: 'Consigned',
                        orderType: 'consigned',
                    });
                    TabLists.push({
                        id: 5,
                        categoryName: 'Consigned',
                        orderType: 'consigned',
                        label: t('receiveSets.tablist.consigned'),
                    });
                }
            }
            setCategoryList(CategoryLists);
            setTabList(TabLists);
        }
    }, [isLanguageChanged, configRule]);

    useEffectWithErrorLogging(() => {
        if (isSubmittedPage) {
            setIsSubmitClicked(isSubmittedPage);
        } else {
            setIsSubmitClicked(false);
        }
    }, []);

    useEffectWithErrorLogging(() => {
        dispatch(storeIsSubmitValue(isSubmitClicked));
    }, [isSubmitClicked]);

    // const [categoryOpen, setCategoryOpen] = useState(false);

    const {
        // appliedCategory,
        appliedQuickFilter,
        appliedFilter,
        appliedView,
    } = useSelector((state) => state.orderFilterReducer);

    const appliedCategory = useSelector(
        (state) => state.createReceiveSetsReducer.appliedCategory
    );

    const { appliedOrderType, appliedOrderStatus } = appliedFilter;
    const { appliedAccount, appliedDistrict, appliedTerritory } = appliedView;

    const setsList = useSelector(
        (state) => state.receiveSetsListDataReducer.receiveSetsListData
    );
    const { accountId, territoryId, receiveSetsLoading } = useSelector(
        (state) => ({
            territoryId: state.receiveSetsReducer.surgeryDetails.territoryId,
            accountId: state.receiveSetsReducer.surgeryDetails.accountId,
            receiveSetsLoading:
                state.createReceiveSetsReducer.receiveSetsLoading,
        })
    );
    const validatedData = useSelector(
        (state) => state.createReceiveSetsReducer.createReceiveSets
    );
    const { startDate, endDate } = filter;

    const isCancelWithoutReason = useSelector(
        (state) => state.noUsageToReportReducer.isCancelWithoutReason
    );

    const cancelUsageResponse = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageResponse
    );
    const isFromOrderDetailsModal = useSelector(
        (state) => state.noUsageToReportReducer.isFromOrderDetailsModal
    );
    useDynatracePageName(pageNames.orders);

    useEffectWithErrorLogging(() => {
        if (
            isCancelWithoutReason &&
            cancelUsageResponse &&
            cancelUsageResponse.statusCode === '200'
        ) {
            if (isFromOrderDetailsModal && cancelUsageResponse.myCaseRef) {
                dispatch(setOrderStatus({ orderStatus: '' }));
                dispatch(getOrderSummaryData());
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: cancelUsageResponse.myCaseRef,
                        orderSummaryModal: true,
                    })
                );
            }
            dispatch(getRefinedOrderListData({ ...appliedUserFilters }));
            dispatch({ type: RESET_CANCEL_USAGE_STATES });
        }
    }, [isCancelWithoutReason, cancelUsageResponse]);

    const {
        account,
        hrefId,
        physician,
        surgeryDate,
        networkId,
        lotSerialNumber,
        myCaseRef,
        sapOrderId,
        purchaseOrderId,
        unidCaseId,
        trackingNumber,
        delivery,
    } = searchParams;

    useEffectWithErrorLogging(() => {
        const checkSearchParamsSet =
            account !== '' ||
            hrefId !== '' ||
            physician !== '' ||
            surgeryDate !== '' ||
            networkId !== '' ||
            lotSerialNumber !== '' ||
            myCaseRef !== '' ||
            sapOrderId !== '' ||
            purchaseOrderId !== '' ||
            unidCaseId !== '' ||
            trackingNumber !== '' ||
            delivery !== '';
        //setShowSearchOrderResultsTable(checkSearchParamsSet);
        dispatch(
            showHideSearchModalAction({ showSearchModal: checkSearchParamsSet })
        );
    }, [searchParams]);

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const onClose = () => {
        setOutsideTerritoryPopup(false);
    };
    // const onCategoryOpenHandler = (e) => {
    //     setCategoryAnchorEl(e.currentTarget);
    //     setCategoryOpen((prevState) => !prevState);
    // };
    //On Category Change , Setting Category Name in local useState, dispatch action to Save Category in reducer,
    //Clear Applied filters and Call API.
    const onCategoryChangeHandler = (Id) => {
        setSelectedTabId(+Id);
        if (Id === selectedTabId) {
            return;
        }
        if (Id == '1') {
            const oldCatList = [...categoryList];
            const categoryIndex = oldCatList.findIndex((cat) => cat.id === +Id);
            const categoryName = categoryList[categoryIndex].categoryName;
            setCategoryName(categoryName);
            dispatch(setCategoryFilter({ ...categoryList[categoryIndex] }));
        } else if (Id == '2') {
            window.location.href = ordersWCMSLinks('sets');
        } else if (Id == '3') {
            window.location.href = ordersWCMSLinks('items');
        } else if (Id == '4') {
            window.location.href = ordersWCMSLinks('returned_sets');
        } else {
            window.location.href = ordersWCMSLinks('consigned');
        }
    };

    useEffectWithErrorLogging(() => {
        if (!linkMyCaseRef) {
            closeOrderSummaryHandler();
        }

        dispatch(
            setSearchParams({
                account: '',
                hrefId: '',
                physician: '',
                surgeryDate: '',
                networkId: '',
                lotSerialNumber: '',
                myCaseRef: '',
                sapOrderId: '',
                purchaseOrderId: '',
                unidCaseId: '',
                trackingNumber: '',
                delivery: '',
            })
        );
        //setShowSearchOrderResultsTable(false);
        dispatch(showHideSearchModalAction({ showSearchModal: false }));
        dispatch(
            setOrderDateAction({
                orderListStartDate: startDate !== '' ? startDate : '',
                orderListEndDate: endDate !== '' ? endDate : '',
            })
        );

        let orderType = '';
        let orderStatus = '';

        const checkDistrictSelectedEmpty =
            Object.keys(appliedDistrict).length === 0 &&
            appliedDistrict.constructor === Object;

        const checkTerritorySelectedEmpty =
            Object.keys(appliedTerritory).length === 0 &&
            appliedTerritory.constructor === Object;

        const checkAccountSelectedEmpty =
            Object.keys(appliedAccount).length === 0 &&
            appliedAccount.constructor === Object;

        const checkCategorySelectedEmpty =
            Object.keys(appliedCategory).length === 0 &&
            appliedCategory.constructor === Object;

        const checkQuickFilterEmpty =
            Object.keys(appliedQuickFilter).length === 0 &&
            appliedQuickFilter.constructor === Object;

        orderType = !checkCategorySelectedEmpty
            ? appliedCategory.categoryName === 'Backorders'
                ? checkAppliedOrderTypeHandler(appliedOrderType)
                : appliedCategory.categoryName === 'Drafts'
                    ? !checkQuickFilterEmpty
                        ? !appliedQuickFilter.isDefault
                            ? appliedQuickFilter.statusCode
                            : checkAppliedOrderTypeHandler(appliedOrderType)
                        : ''
                    : appliedCategory.orderType
            : '';

        orderStatus = !checkQuickFilterEmpty
            ? appliedCategory.categoryName === 'Drafts'
                ? appliedCategory.orderType
                : appliedQuickFilter.isDefault
                    ? checkAppliedOrderStatusHandler(appliedOrderStatus)
                    : appliedQuickFilter?.statusCode &&
                        appliedQuickFilter?.statusCode !== ''
                        ? appliedQuickFilter.statusCode
                        : ''
            : checkAppliedOrderStatusHandler(appliedOrderStatus);

        if (checkCategorySelectedEmpty) {
            dispatch(setCategoryFilter({ ...categoryList[0] }));
            dispatch(setQuickFilter({}));
        } else {
            setCategoryName(appliedCategory.categoryName);
            setSelectedTabId(appliedCategory.id);
        }

        const district = checkDistrictSelectedEmpty
            ? ''
            : appliedDistrict?.id
                ? appliedDistrict.id === 'All District'
                    ? ''
                    : appliedDistrict.id
                : '';
        const territory = checkTerritorySelectedEmpty
            ? ''
            : appliedTerritory?.id
                ? appliedTerritory.id === 'All Territory'
                    ? ''
                    : appliedTerritory.id
                : '';
        const account = checkAccountSelectedEmpty
            ? ''
            : appliedAccount?.id
                ? appliedAccount.id === 'All Account'
                    ? ''
                    : appliedAccount.id
                : '';
        dispatch(actionApplyFilterType('initial'));
        dispatch(getDistrict(true));
        //Normal Flow for Non-QuickFilters
        if (
            checkCategorySelectedEmpty ||
            appliedCategory.categoryName === 'Backorders' ||
            appliedCategory.categoryName === 'Credits/Debits/Returns'
        ) {
            // order list API call is not required in receiveSets
            ()=>{};
            // dispatch(
            //     getOrderListData({
            //         startDate: startDate,
            //         endDate: endDate,
            //         orderTypeFilter: orderType,
            //         orderStatusCodesFilter: orderStatus,
            //         districtFilter: district,
            //         territoryFilter: territory,
            //         accountFilter: account,
            //         pageLimit: appliedUserFilters.pageLimit,
            //         pageNum: '0',
            //         sortOrder: appliedUserFilters.sortOrder,
            //         isActionItem: true,
            //         sortParam: appliedUserFilters.sortParam,
            //     })
            // );
        } else {
            //Two API Flow for QuickFilters
            twoCallAPIHandler(false, false);
        }
        dispatch(
            setActiveNavLink({
                dashboard: false,
                calendar: false,
                admin: false,
                orders: false,
                alerts: false,
                inventory: true,
                more: false,
                deniedUsageOverrides: false,
                productGuide: false,
            })
        );
        dispatch(setReceiveSetUnsavedChangesPopup(false));
        let body = document.getElementById('body');
        if (isMobileView()) {
            body.style.backgroundColor = '#140f4b';
        }
        return () => {
            body.style.backgroundColor = '';
        };
    }, []);

    const twoCallAPIHandler = (isPage, isDateDispatch) => {
        dispatch(
            refineFilterAndOrderList({
                filters: {
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        startDate: isDateDispatch
                            ? orderListStartDate
                            : filter.startDate,
                        endDate: isDateDispatch
                            ? orderListEndDate
                            : filter.endDate,
                        orderType:
                            appliedCategory?.categoryName === 'Drafts' ||
                                appliedCategory.categoryName === 'Backorders'
                                ? ''
                                : appliedCategory.orderType,
                        orderStatusCode:
                            appliedCategory?.categoryName === 'Drafts'
                                ? appliedCategory.orderType
                                : '',
                    },
                    pageLimit: appliedUserFilters.pageLimit,
                    pageNo: isPage ? appliedUserFilters.pageNo : 0,
                },
                appliedQuickFilter: appliedQuickFilter,
                appliedCategory: appliedCategory,
                appliedOrderType:
                    checkAppliedOrderTypeHandler(appliedOrderType),
                appliedOrderStatus:
                    checkAppliedOrderStatusHandler(appliedOrderStatus),
            })
        );
    };

    const checkAppliedOrderTypeHandler = (appliedOrderType) => {
        let orderType = '';

        const selectedOrderType = appliedOrderType
            ?.filter((x) => x.isChecked === true)
            ?.map((a) => {
                if (a.statusCode === 'ALL_ORDERTYPE') {
                    return '';
                }
                return a.statusCode;
            });

        orderType =
            selectedOrderType?.length > 0 ? selectedOrderType.join(',') : '';

        return orderType;
    };

    const checkAppliedOrderStatusHandler = (appliedOrderStatus) => {
        let orderStatus = '';

        const selectedOrderStatus = appliedOrderStatus
            ?.filter((x) => x.isChecked === true)
            ?.map((a) => {
                if (a.statusCode === 'ALL_ORDERSTATUS') {
                    return '';
                }
                return a.statusCode;
            });

        orderStatus =
            selectedOrderStatus?.length > 0
                ? selectedOrderStatus.join(',')
                : '';
        return orderStatus;
    };

    useEffectWithErrorLogging(() => {
        if (linkMyCaseRef) {
            // selectedMycaseRefId(linkMyCaseRef);
            openOrderSummaryHandler(linkMyCaseRef);
        }
    }, [linkMyCaseRef]);

    const openOrderSummaryHandler = (myCaseRef) => {
        //Added for Dynatrace pageName identification
        setDynatracePageName(pageNames.ordersSummary);
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRef,
                orderSummaryModal: !orderSummaryModal,
            })
        );
    };

    const closeOrderSummaryHandler = () => {
        dispatch(setDynamicZIndex(0));
        if (linkMyCaseRef) {
            dispatch(
                closeOrderSummaryModalState({
                    myCaseRef: '',
                    orderSummaryModal: false,
                })
            );
            history.replace({
                pathname: '/orders',
                linkMyCaseRef: '',
            });
        } else {
            dispatch(
                closeOrderSummaryModalState({
                    myCaseRef: '',
                    linkMyCaseRef: '',
                    orderSummaryModal: false,
                })
            );
        }
        if (showSearchModal) {
            dispatch(toggleSearchResult(false));
        }
    };

    // const onAwayClickHandler = () => {
    //     setCategoryOpen(false);
    // };

    const onDiscard = () => {
        setOutsideTerritoryPopup(false);
    };

    let appliedViews = [];
    if (appliedAccount.name) {
        if (appliedAccount.name !== 'All') {
            appliedViews.push(appliedAccount.name);
        }
    }
    if (appliedDistrict.name) {
        if (appliedDistrict.name !== 'All') {
            appliedViews.push(appliedDistrict.name);
        }
    }
    if (appliedTerritory.name) {
        if (appliedTerritory.name !== 'All') {
            appliedViews.push(appliedTerritory.name);
        }
    }

    const getHeightBasedOnMobileView = (quickOrderHeight) => {
        if (innerHeight > 820) {
            return 'calc(100vh - 110px)';
        } else if (innerHeight <= 715) {
            return bannerHeight
                ? 'calc(100vh - 250px)'
                : quickOrderHeight
                    ? 'calc(100vh - 100px)'
                    : 'calc(100vh - 180px)';
        } else if (innerHeight > 715 && innerHeight < 820) {
            return 'calc(100vh - 110px)';
        } else {
            return 'calc(100vh - 110px)';
        }
    };

    const [isScrollHide] = useState(false);

    useEffectWithErrorLogging(() => {
        if (bannerHeight || isMobileDevice()) {
            preventBouncingEffect();
        }
    }, [bannerHeight]);

    const submitBtnClickHandler = (popupSubmit = false) => {
        if (!popupSubmit) {
            if (
                setsOutsideTerritoryList &&
                setsOutsideTerritoryList.length > 0
            ) {
                setOutsideTerritoryPopup(true);
                return;
            } else {
                const data = {
                    accountId: accountId.accountId,
                    accountName: accountId.accountName,
                    sets: setsList,
                    territoryId: territoryId,
                    isSubmit: true,
                };
                if (data != undefined) {
                    dispatch(createReceiveSets(data));
                }
                setIsSubmitClicked(true);
                setTerritoryValue('');
                setAccountValue('');
            }
        } else {
            const data = {
                accountId: accountId.accountId,
                accountName: accountId.accountName,
                sets: setsList,
                territoryId: territoryId,
                isSubmit: true,
            };
            if (data != undefined) {
                dispatch(createReceiveSets(data));
            }
            setIsSubmitClicked(true);
            setTerritoryValue('');
            setAccountValue('');
        }
    };

    useEffectWithErrorLogging(() => {
        return () => {
            //clearing the data
            dispatch(resetSurgeryDetails(''));
            dispatch(deleteAllSets([]));
            dispatch(setBarcodeDetails());
            dispatch(setProductDetails());
            // dispatch(saveSetsOutsideTerritoryList([]));
            dispatch(resetTerritoryReceiveSets());
            dispatch(resetCreateReceiveSets());
            dispatch(resetReceiveSetsListDataReducer());
            dispatch(resetDetailsDropdownsReducer());
            dispatch(storeIsSubmitValue(false));
            dispatch(getConfigurations({resourceType: 'PROCESS'}, MENU));
        };
    }, []);
    const { showDiscardPopup, id } = popupDetails;

    const openDiscardPopup = (id) => {
        setPopupDetails({ ...popupDetails, showDiscardPopup: true, id: id });
    };
    const handleDiscardChanges = () => {
        onCategoryChangeHandler(id);
        setPopupDetails({ ...popupDetails, showDiscardPopup: false, id: null });
        //clearing the data
        dispatch(resetSurgeryDetails(''));
        dispatch(getConfigurations({resourceType: 'PROCESS'}, MENU));
        dispatch(deleteAllSets([]));
        dispatch(setBarcodeDetails());
        dispatch(setProductDetails());
        dispatch(saveSetsOutsideTerritoryList([]));
        dispatch(resetBulkBarcodeDetailsData([]));
        dispatch(bulkBarcodeDetailsData([]));
        dispatch(resetCreateReceiveSets());
        dispatch(resetReceiveSetsListDataReducer());
        dispatch(resetDetailsDropdownsReducer());
        localStorage.removeItem('createReceiveSetError');
    };

    const tabSwitchHandler = (id) => {
        if (id !== selectedTabId) {
            openDiscardPopup(id);
        }
        setSelectedTabId(id);
    };

    useDynatracePageName(pageNames.inventory);
    return (
        
        <>
            <ReceiveSetsHeader />

            <MainContainer
                ref={surgeryContainerRef}
                mobileViewHeight={getHeightBasedOnMobileView()}
                isScrollHide={isScrollHide}
            >
                <Container>
                    {!isSubmitClicked && (
                        // <Category
                        //     categoryName={categoryName}
                        //     categoryOpen={categoryOpen}
                        //     categoryList={categoryList}
                        //     categoryChange={openDiscardPopup}
                        //     //categoryChange={onCategoryChangeHandler}
                        //     categoryOpenHandler={onCategoryOpenHandler}
                        //     categoryAnchorEl={categoryAnchorEl}
                        //     clickAwayHandler={onAwayClickHandler}
                        // />
                        <InventoryTabListContainer
                            inventoryDetailTabList={tabList}
                            tabActiveId={selectedTabId}
                            tabSwitch={openDiscardPopup}
                        />
                    )}
                    {categoryName == 'Receive Sets' && selectedTabId === 1 && (
                        <ReceiveSetsLoc
                            accountValue={accountValue} 
                            setAccountValue ={setAccountValue}
                            territoryValue={territoryValue}
                            setTerritoryValue={setTerritoryValue}
                            isSubmitClicked={isSubmitClicked}
                            setIsSubmitClicked={setIsSubmitClicked}
                            setSetFieldFocus={setSetFieldFocus}
                            counterMessage={counterMessage}
                            setCounterMessage={setCounterMessage}
                        />
                    )}
                </Container>
            </MainContainer>
            {!isSubmitClicked && (
                <ReceiveSetsFooter
                    setIsSubmitClicked={setIsSubmitClicked}
                    setsList={setsList}
                    submitBtnClickHandler={submitBtnClickHandler}
                    setFieldFocus={setFieldFocus}
                    counterMessage={counterMessage}
                    setCounterMessage={setCounterMessage}
                    setAccountValue={setAccountValue}
                    setTerritoryValue={setTerritoryValue}
                />
            )}
            {outsideTerritoryPopup && (
                <SetsManualEntry
                id="receivesets-setsmanualentry-popup"
                    setsOutsideTerritoryList={setsOutsideTerritoryList}
                    onClose={onClose}
                    onDiscard={onDiscard}
                    onSubmit={() => {
                        try {
                        submitBtnClickHandler(true);
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {showDiscardPopup ? (
                <UnsavedChanges
                 id="receivesets-unsavedchanges-popup"
                    onDiscard={handleDiscardChanges}
                    onClose={() =>
                        setPopupDetails({
                            ...popupDetails,
                            showDiscardPopup: false,
                            id: null,
                        })
                    }
                />
            ) : null}
            {/* {showNotificationPopup && !outsideTerritoryPopup && (
                <NotAbleToReceiveSets onClose={closeNotificationPopup} />
            )} */}
            {receiveSetsLoading || userDetailsLoading  && (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="receiveSets-index-backdrop-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                </Backdrop>
            )}
        </>
        
    );
};

export default ReceiveSets;

const getHeightBasedOnView = (
    quickOrder,
    productGuide,
    modifySurgery,
    surgerySuccess,
    bannerMargin
) => {
    const banner = bannerMargin ? bannerMargin : '0px';
    let height = `calc(100vh - 195px - ${banner})`;
    if (quickOrder) {
        height = `calc(100vh - 194px - ${banner})`;
    } else if (modifySurgery) {
        height = `calc(100vh - 230px - ${banner})`;
    } else if (surgerySuccess) {
        height = `calc(100vh - 100px - ${banner})`;
    } else if (productGuide) {
        height = `calc(100vh - 145px - ${banner})`;
    }
    return height;
};

const MainContainer = styled.div`
    margin: 0;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    opacity: 1;
    overflow: hidden;
    overflow-y: ${(props) => (props.isScrollHide ? 'none' : 'scroll')};
    padding: 0px 2px;

    /* overflow-x: hidden; */
    &::-webkit-scrollbar {
        display: ${(props) =>
        props.isScrollHide ? '' : props.theme.scrollOption.show};
        width: ${({ theme }) => theme.scrollOption.width};
    }
    &::-webkit-scrollbar-track {
        margin-top: 10px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }
    height: ${(props) =>
        !props.productTemplateHeight &&
        getHeightBasedOnView(
            props.quickOrderHeight,
            props.productGuideHeight,
            props.isModifySurgery,
            props.surgerySuccess,
            props.bannerMargin,
            props.isSubmitClicked
        )};
    ${media.mediumDevice`
        height:${(props) =>
            !props.productTemplateHeight &&
            (props.bannerMargin
                ? `calc(100vh -220px - ${props.bannerMargin})`
                : 'calc(100vh - 220px)')};
        &::-webkit-scrollbar {
            display: none;
        }
        overflow-x: hidden;
    `}

    @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation: landscape) {
        height: ${(props) =>
        !props.productTemplateHeight && 'calc(100vh - 180px)'};
        padding-bottom: 42px;
    }

    ${media.mobileDevice`
        //Horizontal scroll remove
        overflow-x: hidden;
        width: 100%;
        //  curve issue
        border-top-left-radius: ${({ hideBorderRadius }) =>
            hideBorderRadius ? '0px' : '25px'};
        border-top-right-radius: ${({ hideBorderRadius }) =>
            hideBorderRadius ? '0px' : '25px'};
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        padding: 0 0 15px 0;
        height: ${(props) =>
            !props.productTemplateHeight && props.mobileViewHeight};
        //white line issue
        margin-top:  0.9rem;
        overflow-y: ${(props) =>
            props.quickOrderHeight || props.isProductGuide
                ? 'hidden'
                : 'scroll'};
    `};

    ${media.mediumDevice`
        &::-webkit-scrollbar {
            display: none;
            width: 0;
        }
    `}

    @media only screen and (min-width: 1110px) and (max-width: 1150px) and (orientation: landscape) {
        &::-webkit-scrollbar {
            display: none;
            width: 0;
        }
    }
`;

const Container = styled.div`
    padding-bottom: 120px;
    ${media.mobileDevice`
        height: auto;
        width: auto;
        margin-top: 0%;
        padding: 20px 20px 240px 20px;
    `}
`;
